let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eS2fq")).then(() => parcelRequire('5T2wS'));